import { MultiSelectDropdown } from "capitalrx-components-2.0/lib/forms";
import moment from "moment";

const checkString = (data) => {
  if (Array.isArray(data) && data.length) return data;
  if (typeof data === "string" && data.length) return data.split(",").map((id) => id.trim());

  return [];
};

export const formatDate = (date: unknown, formatStr = "MM/DD/YYYY"): string => {
  if (date === null) return "";
  return moment.utc(date).format(formatStr);
};

export const formatSubmittingData = (data) => {
  const newData = {
    ...data,
    network_ids: checkString(data.network_ids),
    price_list_ids: checkString(data.price_list_ids),
    provider_agreement_ids: checkString(data.provider_agreement_ids),
    relationship_ids: checkString(data.relationship_ids),
    service_provider_ids: checkString(data.service_provider_ids),
    multi_source: data.multi_source || [],
    minimum_date_of_service: formatDate(data.minimum_date_of_service, "MM/DD/YYYY"),
    maximum_date_of_service: formatDate(data.maximum_date_of_service, "MM/DD/YYYY"),
    minimum_claim_submission_date: formatDate(data.minimum_claim_submission_date, "MM/DD/YYYY"),
    maximum_claim_submission_date: formatDate(data.maximum_claim_submission_date, "MM/DD/YYYY"),
  };

  Object.keys(newData).forEach((key) => {
    if (newData[key] === "") {
      newData[key] = null;
    }
  });

  return newData;
};

export const transformObjectToArray = (obj) => {
  return Object.entries(obj).map(([key, value]) => ({
    type: key,
    value: value,
  }));
};

export const formatIncommingData = (data) => {
  const newData = {
    ...data,
    multi_source: data.multi_source,
    compound_pricing: transformObjectToArray(data.compound_pricing),
  };

  return newData;
};

export const formatStringArray = (values: string[]) => {
  return values.map((value) => value.charAt(0).toUpperCase() + value.slice(1)).join(", ");
};

/**
 * Takes a single list of multiselect dropdown options data.
 * Returns ready made made options for MultiSelectDropdown
 * @param {SelectStringValue[]} data list in the form `[{value: string, label: string}, ...]`
 * @returns list in the form `[<MultiSelectDropdown.Option ...></MultiSelectDropdown.Option>, ...]`
 */
export const generateMultiSelectDropdownOptions = (data) => {
  return data.map(({ value, label }) => (
    <MultiSelectDropdown.Option key={value} value={value}>
      {label}
    </MultiSelectDropdown.Option>
  ));
};

export const transformArrayToObject = (arr) => {
  return arr
    .filter((item) => item.type !== "null" && item.type !== null)
    .reduce((acc, item) => {
      acc[item.type] = item.value;
      return acc;
    }, {});
};

export const formatOutgoingData = (data) => {
  const formattedData = {
    ...data,
    compound_pricing: transformArrayToObject(data.compound_pricing),
  };

  return formattedData;
};
